(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    /**
   * Video autoplay on hover — desktop only, zero first-load cost.
   *
   * No IntersectionObserver, no background preloading — nothing is
   * fetched until the user's pointer actually enters a card. This
   * protects LCP/FCP on first load: images and critical assets load
   * uncontested by video network requests.
   *
   * Speed trick: buffering starts on pointerover of the CARD (not just
   * the image). The pointer has ~100-300 ms of travel time from the card
   * edge to the image, giving the browser a head start on the video data.
   * By the time mouseover fires on the image, readyState is often >= 3
   * (HAVE_FUTURE_DATA) and the video plays instantly.
   *
   * If the pointer reaches the image before buffering finishes, the
   * product image stays visible (no white flash) and the video fades in
   * as soon as the 'canplay' event fires.
   */
  (function () {
    // Desktop-with-hover only — skips touch phones, tablets, etc.
    if (window.matchMedia('(hover: none)').matches) return;

    function loadVideoSources(video) {
      if (video._loaded) return;
      video._loaded = true;
      var sources = video.querySelectorAll('source[data-src]');
      for (var i = 0; i < sources.length; i++) {
        sources[i].src = sources[i].getAttribute('data-src');
        sources[i].removeAttribute('data-src');
      }
      video.load();
    }

    // Start buffering as soon as the pointer enters the card —
    // gives a head start before the pointer reaches the image area.
    document.addEventListener('pointerover', function (e) {
      var gallery = e.target.closest('[data-hover-video-autoplay]');
      if (!gallery) return;
      var video = gallery.querySelector('.card-gallery__hover-video');
      if (video) loadVideoSources(video);
    }, { passive: true });

    // Show and play once the pointer is over the image area
    document.addEventListener('mouseover', function (e) {
      var gallery = e.target.closest('[data-hover-video-autoplay]');
      if (!gallery || gallery._hoverVideoActive) return;
      gallery._hoverVideoActive = true;

      var video = gallery.querySelector('.card-gallery__hover-video');
      if (!video) return;

      loadVideoSources(video); // no-op if pointerover already fired

      if (video._canplayHandler) {
        video.removeEventListener('canplay', video._canplayHandler);
        video._canplayHandler = null;
      }

      if (video.readyState >= 3) {
        // Enough data buffered — show and play immediately
        video.classList.add('is-playing');
      } else {
        // Still buffering — keep image visible, reveal video when ready
        video._canplayHandler = function () {
          video.removeEventListener('canplay', video._canplayHandler);
          video._canplayHandler = null;
          if (gallery._hoverVideoActive) video.classList.add('is-playing');
        };
        video.addEventListener('canplay', video._canplayHandler);
      }

      video.play().catch(function () {});
    }, { passive: true });

    document.addEventListener('mouseout', function (e) {
      var gallery = e.target.closest('[data-hover-video-autoplay]');
      if (!gallery) return;
      if (gallery.contains(e.relatedTarget)) return;
      gallery._hoverVideoActive = false;

      var video = gallery.querySelector('.card-gallery__hover-video');
      if (!video) return;

      if (video._canplayHandler) {
        video.removeEventListener('canplay', video._canplayHandler);
        video._canplayHandler = null;
      }

      video.pause();
      video.currentTime = 0;
      video.classList.remove('is-playing');
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
